import useSWRImmutable from "swr/immutable";
import { useApi } from "../api";
import { CustomError } from "../errors";
import { BorderSettings } from "./types/borderSettings";

export const useBorderSettingsApi = () => {
  const api = useApi();

  const useBorderSettings = (signal: AbortSignal, configurationId?: string) => {
    const url = `/settings/border${configurationId ? `?configuration_id=${configurationId}` : ""}`;
    return useSWRImmutable<BorderSettings, CustomError, string>(url, (url) => api.get<BorderSettings>({ url, signal }));
  };

  return {
    useBorderSettings,
  };
};
